import React from "react";
import BuildModalHeader from "../BuildModalHeader";

export default function ReportsFullView({ selectedReport, onCancel }) {
    return (
        <div className="modal modal-region helper-full-view-modal" style={{ display: "block" }}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <BuildModalHeader title={selectedReport.file_name} onCancel={onCancel} modalClass="helper-full-view-modal" />
                    <div className="modal-body region-otr">
                        {selectedReport.url ? (
                            <video poster={selectedReport.poster} controls disablePictureInPicture style={{ width: "100%" }}>
                                <source src={selectedReport.url} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <p>Loading...</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
